import { TFileUploaded } from '../../../../../types';

export const getFilePropValue = (
  filePropObj?: string,
): Record<string, TFileUploaded> => {
  if (filePropObj && filePropObj?.length > 0) {
    const parsedfilePropObj = filePropObj?.replace(
      /([{,])(\s*)([A-Za-z0-9_-]+?)\s*:/g,
      '$1"$3":',
    );

    const props = eval(`(${parsedfilePropObj})`) as Record<
      string,
      TFileUploaded
    >;
    return props;
  }
  return {};
};
